import { inject, injectable } from 'inversify';
import { SuspendDataStore, SuspendDataStoreSymbol, SuspendDataStateStore } from '@/app/tracking/common';
import { QuizSessionTrackingState, defaultQuizSessionTrackingState } from './quiz-session-tracking-state';
import { QuizSessionCommand, quizSessionReducer } from './quiz-session-state-reducer'

interface QuizSessionSuspendData {
  quizSessions: QuizSessionTrackingState[];
}

@injectable()
export class QuizSessionSuspendDataStore {

  private store: SuspendDataStateStore<QuizSessionTrackingState, unknown, QuizSessionCommand>;

  constructor(
    @inject(SuspendDataStoreSymbol)
    suspendDataStore: SuspendDataStore<QuizSessionSuspendData>) {

    this.store = new SuspendDataStateStore(
      () => suspendDataStore.get2('quizSessions'),
      (data: QuizSessionTrackingState[]) => suspendDataStore.update2('quizSessions', data),
      (id) => defaultQuizSessionTrackingState(id),
      quizSessionReducer);
  }

  public async query(ids: string[] | 'all') {
    return this.store.query(ids);
  }

  public async execute(command: QuizSessionCommand) {
    await this.store.execute(command);
  }
}
